module.exports = __webpack_public_path__ + "img/zhxy_image_15.6cc73b8d.png";